import { ReactNode } from 'react'
import { isNil } from 'lodash'
import { useReselector } from '@/utils/sharedHooks'
import { UploadDocumentType } from '@/constants/businessConstants'
import { getUserDocumentsByCategoryInternalName } from '@/features/user/your-practice/documents/lib/userDocuments.selector'

import { TypographyStyles, TextColors } from '@/styles'
import { Link, Popup, Text } from '@/ui'

import { selectUserDocumentCategoryByInternalName } from '@/features/admin/user-document-categories/userDocumentCategories.selectors'

interface IPracticeProfileEntry {
  label: string
  value?: string | number | null
  popupContent?: ReactNode
  documentCat?: string
  documentType?: UploadDocumentType
  taxYear?: string
  uploadItem?: ReactNode
}

export const PracticeProfileEntry = ({
  label,
  value,
  popupContent,
  documentCat,
  uploadItem,
}: IPracticeProfileEntry) => {
  const taxDocCat = useReselector(
    selectUserDocumentCategoryByInternalName,
    documentCat
  )

  const userDocs = useReselector(
    getUserDocumentsByCategoryInternalName,
    documentCat
  )

  return (
    <div className="flex flex-col md:flex-row text-left gap-2 mb-4 items-start md:items-center">
      <Text className="w-full md:w-3/10" variant={TypographyStyles.LABEL_SM}>
        {label}
        {popupContent && <Popup content={popupContent} />}
      </Text>

      <div className="w-full md:w-7/10">
        {!isNil(value) && (
          <Text variant={TypographyStyles.BODY_SM} color={TextColors.MUTED}>
            {value}
          </Text>
        )}

        {userDocs.map((doc) =>
          doc?.signedUrl ? (
            <Link
              key={doc.id}
              className="w-full"
              href={doc.signedUrl}
              variant="primary"
              color={TextColors.MUTED}
            >
              {doc?.fileDescription}
            </Link>
          ) : (
            <Text
              key={doc.id}
              variant={TypographyStyles.BODY_SM}
              color={TextColors.MUTED}
            >
              {doc?.fileDescription}
            </Text>
          )
        )}

        {taxDocCat && !userDocs.length && uploadItem}
      </div>
    </div>
  )
}
